import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { resetEmailResponse, resetLoginResponse, showModal } from "../../redux/actions";
import { getCapitalized } from "../../utils/helper";
const MyLearnerPlanRedirectPopup = ({ handleRedirectPopUp }) => {
    const history = useHistory();
    const dispatch = useDispatch();

    const { defaultChildData, loggedInUser } = useSelector((state) => state.collections);

    const hideShowBox = () => {
        dispatch(showModal());
        dispatch(resetLoginResponse());
        dispatch(resetEmailResponse());
    };

    return (
        <div className="sharepopup  AreyousurePopup areyousurenewpopup newuipopupchanges welcome_new_poup RootContent">
            <div className="modal  show d-flex" id="schoolactivity161" role="dialog">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content courseInformation schoolcourse ">
                        <div className="modal-header">
                            <h2 className="flexone w-100">
                                {/* <span>Create a Growth Plan for {getCapitalized(defaultChildData?.firstName)}</span> */}
                                <span>Your Child’s Learning Journey Awaits</span>
                                <button onClick={() => dispatch(showModal())} class="closebtn" data-dismiss="modal"><i class="fa-regular fa-xmark"></i></button>
                                {/* <div onClick={() => hideShowBox()}>
                               
                            </div> */}
                            </h2>
                        </div>

                        <div className="modal-body p-2 mx-3">
                            <div className="sharewithfrnd ">
                                {/* <h3 className="text-center">Welcome to the Plan builder!</h3> */}
                                {/* <p className="mb-3 pb-2 pt-2 mt-3 text-left" >
                                    You do not currently have a Plan for {getCapitalized(defaultChildData?.firstName)}.
                                    Building a plan only takes a few minutes and can be changed or added at any time. Click below to begin, you will see a recommended plan to start with.
                                </p> */}

                                {/* <p className="p1 mb-3 pb-2 pt-2  text-left" >
                                    It looks like you haven’t created a Growth Plan for {getCapitalized(defaultChildData?.firstName)} just yet.
                                    <br/>
                                    Pick 2–4 areas where you’ve noticed challenges or concerns in  {getCapitalized(defaultChildData?.firstName)}'s  behavior. We’ll craft a tailored Growth Plan with the right resources and courses to support him.
                                     <br/>
                                    It only takes a few minutes and can be updated whenever needed.                                    
                                </p> */}
                                <p className="p1 mb-3 pb-2 pt-2  text-left" >
                                    No plans yet—let’s change that! Visit the Course Catalog to pick a single course, an event-focused plan, or a challenge-based plan and start {getCapitalized(defaultChildData?.firstName)}'s learning journey today.                                    
                                </p>
                            </div>
                            {/* <div className="welcomeAgain_Poup skipnow p-5 pt-2 pb-2">
                                <ul className="flex pointer">
                                    <li >
                                        <p className="pointer">Skip Now</p>
                                    </li>
                                </ul>
                            </div> */}
                            <div className="modal-footer">
                                <div className="form-group  d-flex justify-content-end m-0">
                                    {/* <button
                                        type="button"
                                        className="btn-blue btn-login d-block mb-5 cancelbutton"
                                        onClick={() => dispatch(showModal())}
                                    >
                                        Skip Now
                                    </button> */}
                                    <button
                                        type="button"
                                        className="mybutton"
                                        onClick={() => handleRedirectPopUp(false)}
                                        //  onClick={() => dispatch(showModal())}
                                    >
                                        Explore Course Catalog
                                    </button>
                                </div>
                                {/* <ul className="flex ">
                                    <li onClick={() => dispatch(showModal())}>
                                        <p className="pointer">Skip Now</p>
                                    </li>
                                </ul> */}
                            </div>
                            {/* {loggedInUser?.role?.name === "PARENT" && (
                                <div className="welcomeAgain_Poup skipnow p-5 pt-2 pb-2">
                                    <ul className="flex pointer">
                                        <li onClick={() => dispatch(showModal())}>
                                            <p className="pointer">Skip Now</p>
                                        </li>
                                    </ul>
                                </div>
                            )} */}
                            {/* <div className="buttonDistribotion justify-content-center flex-wrap mt-3 skipnow">
                                {
                                    loggedInUser?.role?.name === "PARENT" ? (
                                        <button
                                            type="button"
                                            className="btn-blue btn-login d-block mb-5 w-auto"
                                            onClick={() => handleRedirectPopUp(false)}
                                        >
                                            Create Plan
                                        </button>
                                    ) : (
                                        <ul className="flex ">
                                            <li onClick={() => dispatch(showModal())}>
                                                <p className="pointer">Skip Now</p>
                                            </li>
                                        </ul>
                                    )
                                }
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default MyLearnerPlanRedirectPopup;